import axios from "axios";
import { API_Endpoints } from "./API_Endpoints";
import axiosInstance from "./axios";
export const CreateAuctionService = (data: any) => {
  return axiosInstance
    .post(API_Endpoints.Auctions.CREATE_AUCTION, data)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetAuctionsService = () => {
  return axiosInstance
    .get(API_Endpoints.Auctions.GET_AUCTIONS)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetPreviousAuctionsService = () => {
  return axiosInstance
    .post(API_Endpoints.Auctions.PREVIOUS_AUCTIONS, { previous: "previous" })
    .then((res) => res.data)
    .catch((err) => err);
};
export const GetCurrentAuctionsService = () => {
  return axiosInstance
    .post(API_Endpoints.Auctions.CURRENT_AUCTIONS, { current: "current" })
    .then((res) => res.data)
    .catch((err) => err);
};

export const DeleteAuctions = (id: any) => {
  return axiosInstance
    .delete(`${API_Endpoints.Auctions.DELETE_AUCTION}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetAdminAuctions = (pageNumber: number) => {
  return axiosInstance
    .get(`${API_Endpoints.Admin.GET_AUCTIONS}?page=${pageNumber}&limit=10`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const SearchAuctionsService = (data: {
  keyword?: string;
  radius?: string;
  category?: string;
  lat?: number;
  lng?: number;
  region?: string;
  zip?: string;
}) => {
  let params: any = {};
  if (data.keyword) {
    params.keyword = data.keyword;
  }
  if (data.radius) {
    params.radius = data.radius;
  }
  if (data.category) {
    params.category = data.category;
  }
  if (data.lat && data.lng) {
    params.lat = data.lat;
    params.lng = data.lng;
  }
  if (data.region) {
    params.region = data.region;
  }
  if (data.zip) {
    params.zip = data.zip;
  }

  return axiosInstance
    .post(`${API_Endpoints.Auctions.SEARCH_AUCTIONS}`, params)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetRegionsService = () => {
  return axiosInstance
    .get(`${API_Endpoints.Auctions.GET_REGIONS}`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const GetAuctionDetail = (id: any) => {
  return axiosInstance
    .get(`${API_Endpoints.Auctions.GET_AUCTION_DETAIL}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};

export const EditAuctionService = (data: any) => {
  return axiosInstance
    .put(`${API_Endpoints.Auctions.GET_AUCTION_DETAIL}/${data.id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const GetAdminAuctionsDetail = (id: any) => {
  return axiosInstance
    .get(`${API_Endpoints.Admin.GET_AUCTION_DETAILS}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const EditAdminAuction = (data: any) => {
  return axiosInstance
    .put(`${API_Endpoints.Admin.GET_AUCTION_DETAILS}/${data.id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};
export const DeleteAdminAuctions = (id: any) => {
  return axiosInstance
    .delete(`${API_Endpoints.Admin.DELETE_AUCTIONS}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};
